import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { formField } from "../../../Theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: 130,
      width: `calc(100vw - ${theme.layout.leftDrawerWidth}px - 104px)`,
      [theme.breakpoints.down("md")]: {
        width: `calc(100vw - 102px)`,
      },
      marginLeft: theme.spacing(12),
      marginRight: theme.spacing(14),
    },
    headerText: {},
    headerSubtitle: {
      marginTop: theme.spacing(2),
    },
    addIcon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 20,
      height: 75,
      marginBottom: -36,
      "& div": {
        backgroundColor: theme.palette.secondary.main,
        width: 40,
        height: 40,
        borderRadius: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      "& svg": {
        color: theme.palette.common.white,
        width: 24,
        height: 24,
      },
    },
    form: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0px 6px 20px 0 rgba(193, 207, 217, 0.2)",
      [theme.breakpoints.down("md")]: {
        boxShadow: "0px 6px 0 0 rgba(193, 207, 217, 0.2)",
      },
      paddingBottom: 90,
    },
    grid: {
      marginTop: theme.spacing(8),
      maxWidth: 1180,
    },
    gridItem: {
      padding: "12px 70px 12px 70px",
      [theme.breakpoints.down("md")]: {
        padding: "12px 70px 12px 0",
      },
    },
    formField: {
      width: 450,
      ...formField,
    },
    upload: {
      width: 450,
      marginTop: 23,
      display: "flex",
      justifyContent: "space-between",
      textTransform: "initial",
      fontSize: 14,
      fontWeight: "normal",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: 0,
      borderBottom: `3px solid ${theme.colors.lightGrey}`,
    },
    isActive: {
      marginTop: 18,
      marginLeft: 0,
      marginRight: 0,
      width: 450,
      borderBottom: `3px solid ${theme.colors.lightGrey}`,
    },
    helperText: {
      color: theme.colors.mediumGrey,
    },
    companyLogoHelperText: {
      marginTop: 11,
    },
    actions: {},
    submit: {
      marginTop: 87,
      width: 338,
      marginLeft: 10,
      textTransform: "initial",
      color: theme.palette.common.white,
    },
    backLink: {
      textDecoration: "none",
    },
    alert: {
      marginTop: theme.spacing(4),
      width: 450,
    },
    visible: {
      display: "block",
    },
    hidden: {
      display: "none",
    },
    companyLogoAvatar: {
      height: 32,
      width: 250,
      justifyContent: "left",
    },
    companyLogoAvatarImg: {
      height: "inherit",
      width: "unset",
      maxHeight: 32,
      maxWidth: 250,
    },
    logoFormField: {
      position: "relative",
    },
    removeLogoLink: {
      position: "absolute",
      top: 12,
      right: 38,
      cursor: "pointer",
    },
  })
);

export default useStyles;
